import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './password-group.types';

export const passwordGroupSelectors = {
  ...generateResourceSelectors<types.IPasswordGroup>((state) => state.resource.passwordGroup),
};
